<script>
export let link;
export let id_unico="";
export let id="";
export let acesso=0;
let passagemModal=null;
let passagemModalDelecao=null;
let passagemModalEdicao=null;
let edicao=false;

import CaixaDialogo from "./modal_pergunta.svelte";
import {createEventDispatcher } from 'svelte';

const dispatch = createEventDispatcher();
function VisitarSite(){ 
    let url ="http://en-curta.me/_"+link;
    console.log(url);
    window.location.href=url;
}

function DeletarSite(){
      passagemModal={
         abrirModal:true,
         titulo:"Deletar",
         mensagem:"Certeza que deseja deletar esse microssite? Essa operação não poderá ser desfeita",
         botaoNegativo:"Cancelar",
         botaoPositivo:"Confirmar"

     }
}
function EditarSite(){
      passagemModalEdicao={
         abrirModal:true,
         titulo:"Editar",
         mensagem:"Certeza que deseja editar esse microssite?",
         botaoNegativo:"Cancelar",
         botaoPositivo:"Confirmar"

     }
}

function Editar(){
    console.log("chamando edicao")
    dispatch('ChamarTela', '{"tela":"construtoredicao","id":"'+id_unico+'"}');
}
function Deletar(){
  passagemModal=null;
    
     console.log('aqui');
     
  var data = new FormData();
  data.append("id", id);
  
	fetch('http://microsites.en-curta.me/svelte/deletar.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
  console.log(text);
 
  if(text=="sucesso"){
        
     passagemModalDelecao={
         abrirModal:true,
         titulo:"Deleção",
         mensagem:"Microssite deletado com sucesso",
         botaoNeutro:"Ok"
         

     }
      
  }
  else 
 {
     passagemModalDelecao={
         abrirModal:true,
         titulo:"Erro",
         mensagem:"Erro ao tentar apagar microssite. Tente novamente!",
         botaoNeutro:"Ok"
         

     }
       
 }

  
  
  
  }) 
  
})
.catch((error) => {
  console.error('Error:', error);
   passagemModalDelecao={
         abrirModal:true,
         titulo:"Erro",
         mensagem:"Erro de comunicação. Verifique sua rede!",
         botaoNeutro:"Ok"
         

     }
});


}

function AtualizaLista(){
    console.log("atualiza lista");
   dispatch("RefreshLista");
}

</script>

<style>
.celula{
    margin-left:2px;
    margin-right:2x;
    
    padding:2px;
    
   
    box-shadow: 0px 0px  1px 0.1px gray;
}
.espaco
{

  margin:5px;
 
}
.espaco-celulas{
    margin:10px;
    padding: 12px;
    border-style:right;

}

.img-pequena{
    width:20px;
    margin-right: 10px
}

.separa-bordas{


padding-left: 1px;
padding-right: 1px;

}

</style>

{#if passagemModal!=null}
 <CaixaDialogo  passagemModal={passagemModal} on:CliquePositivo={Deletar}/>
{/if}
{#if passagemModalDelecao!=null}
 <CaixaDialogo  passagemModal={passagemModalDelecao} on:CliqueNeutro={AtualizaLista}/>
{/if}
{#if passagemModalEdicao!=null}
 <CaixaDialogo  passagemModal={passagemModalEdicao} on:CliquePositivo={Editar}/>
{/if}
<div class="conteiner">
    <div class="row celula espaco-celulas">
        <div class="col-lg-7  col-md-6 col-12">
            {link}
        </div>
        <div class="col-lg-2  col-md-3 col-6 ">
            Acessos:{acesso}
        </div>
       
        <div class="col-lg-3 col-md-3 col-6 d-flex justify-content-end">
            <span>
            <img class="thumbnail img-pequena" src="img/trash.png" alt="edit" on:click={()=>DeletarSite()}>
            </span>
            <span>
            <img class="thumbnail img-pequena separa-bordas" src="img/edit.png"  on:click={()=>EditarSite()} alt="edit">
            
            </span>
            
        
             
            <a href={"http://en-curta.me/_"+link}><img class="thumbnail img-pequena"  src="img/eye.png" alt="ir"></a>
        </div>
    </div>
</div>





